import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import config from "../../../baseConfig/index";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import Modal from "../../Fragments/Modal";
import SimpleCrypto from "simple-crypto-js";
import ErrorModal from "../../Fragments/ErrorModal";

class MobileStep3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: false,
      password: "",
      rePassword: "",
      passwordMaxLength: 8,
      agreeWithTerms: 0,
      formResponse: "",
      successModal: false,
      showErrorModal: false,
    };

    this.signIn = this.signIn.bind(this);
  }

  successModal() {
    if (!this.state.successModal) {
      return "";
    }

    return (
      <Modal
        title={trans(this.props.trans, "auth.register.success.title")}
        description={trans(
          this.props.trans,
          "auth.register.success.description"
        )}
        agreeText={trans(this.props.trans, "auth.register.success.agree")}
        agreeAction={this.signIn}
      />
    );
  }

  calcStepWidth() {
    return (
      (100 / this.props.mobileConfig.mobileMaxStep) *
      this.props.mobileConfig.mobileStep
    );
  }

  initLogoutTimer() {
    setTimeout(() => {
      this.props.cookies.remove("loginToken");
      this.props.history.push(config.urlPrefix);
    }, config.logoutTimer);
  }

  signIn() {
    ApiManager.postRequest(
      {
        username: this.props.mobileConfig.mobileMsisdn,
        password: this.state.password,
        _token: this.props.csrf_token.data,
      },
      "/login"
    ).then(
      (resolve) => {
        if (resolve.data.status === "OK") {
          let simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
          this.props.cookies.set(
            "loginToken",
            simpleCrypto.encrypt(resolve.data.jwt),
            { path: config.urlPrefix }
          );
          this.props.history.push(config.urlPrefix + "profile");
          this.initLogoutTimer();
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  sendData(event) {
    this.setState({ buttonLoading: true });
  const prefix = this.props.mobileConfig?.currentTabIndex === 0 ? "mob" : "email";
    ApiManager.postRequest(
      {
        agree_with_terms: this.state.agreeWithTerms,
        token: this.props.mobileConfig.mobileToken,
        _token: this.props.csrf_token.data,
        password: this.state.password,
        password_confirmation: this.state.rePassword,
      },
      `/register/${prefix}/set-password`
    ).then(
      (resolve) => {
        this.setState({
          buttonLoading: false,
          formResponse: resolve.data,
        });

        if (resolve.data.status === "OK") {
          this.setState({ successModal: true });
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
    event.preventDefault();
  }

  toggleCheckbox(event) {
    this.setState({
      agreeWithTerms: event.target.checked ? 1 : 0,
    });
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    let passwordsCountIsValid =
        this.state.password.length >= this.state.passwordMaxLength &&
        this.state.rePassword.length >= this.state.passwordMaxLength,
      errorPasswordClass = "",
      errorPasswordBox = "",
      errorPasswordConfirmClass = "",
      errorPasswordConfirmBox = "",
      errorAgreeWithTermsClass = "",
      errorAgreeWithTermsBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("password")) {
          errorPasswordClass = " form-error";
          errorPasswordBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.password}
            </div>
          );
        }

        if (
          this.state.formResponse.errors.hasOwnProperty("password_confirmation")
        ) {
          errorPasswordConfirmClass = " form-error";
          errorPasswordConfirmBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.password_confirmation}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("agree_with_terms")) {
          errorAgreeWithTermsClass = " form-error";
          errorAgreeWithTermsBox = (
            <div className="form-error-text form-error-text--top-space fs11">
              {this.state.formResponse.errors.agree_with_terms}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("token")) {
          errorBox = (
            <FormMiddlewareError
              message={this.state.formResponse.errors.token}
            />
          );
        }
      }

      if (this.state.formResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={this.state.formResponse.message}
            trans={this.props.trans}
          />
        );
      }
    }

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          onSubmit={(event) => this.sendData(event)}
        >
          <div className="form__form-box form__form-box--with-space form-box">
            <div className="form__sub-title db fs11">
              {this.props.mobileConfig.mobileStep}{" "}
              {trans(this.props.trans, "auth.register.step.title")}{" "}
              {this.props.mobileConfig.mobileMaxStep}
              {trans(
                this.props.trans,
                "auth.register.step" + this.props.mobileConfig.mobileMaxStep
              )}
            </div>
            <div className="form__step-out">
              <div
                className="form__step"
                style={{ width: this.calcStepWidth() + "%" }}
              ></div>
            </div>
          </div>
          <div className="form__form-box">
            <label className="form__label db fs11" htmlFor="tel-number">
              {this.props.mobileConfig?.currentTabIndex === 0
                ? trans(this.props.trans, "auth.register.phone.title2")
                : trans(this.props.trans, "auth.email.title")}
            </label>
            <div className="form__field-out form__field-out--with-prefix pr">
              <input
                style={{
                  paddingLeft: 10,
                }}
                className="form__field fs13 disabled"
                disabled="disabled"
                id="tel-number"
                type="text"
                name="tel-number"
                value={this.props.mobileConfig.mobileMsisdn}
              />
            </div>
          </div>

          <div className={`form__form-box${errorPasswordClass}`}>
            <label className="form__label db fs11" htmlFor="password">
              {trans(this.props.trans, "auth.register.phone.password2")}
            </label>
            <div className="form__field-out pr">
            <input
                type="text"
                name="fake-user"
                autoComplete="password"
                style={{ display: "none" }}
                onChange={() => {}}
                value=""
              />
              <input
                className="form__field fs13"
                id="password"
                type="password"
                name="password"
                placeholder={trans(
                  this.props.trans,
                  "auth.register.phone.password2.placeholder"
                )}
                value={this.state.password}
                onChange={(event) => {
                  this.setState({ password: event.target.value.trim() });
                }}
              />
            </div>
            {errorPasswordBox}
            <div className="form__details-txt fs11">
              {trans(this.props.trans, "auth.register.phone.note")}
            </div>
          </div>

          <div
            className={`form__form-box form__form-box--with-space${errorPasswordConfirmClass}`}
          >
            <label className="form__label db fs11" htmlFor="password-again">
              {trans(this.props.trans, "auth.register.phone.re-password")}
            </label>
            <div className="form__field-out pr">
              <input
                type="text"
                name="fake-user"
                autoComplete="username"
                style={{ display: "none" }}
                onChange={() => {}}
                value=""
              />
              <input
                className="form__field fs13"
                id="password-again"
                type="password"
                name="password-again"
                placeholder={trans(
                  this.props.trans,
                  "auth.register.phone.re-password.placeholder"
                )}
                value={this.state.rePassword}
                onChange={(event) => {
                  this.setState({ rePassword: event.target.value.trim() });
                }}
              />
            </div>
            {errorPasswordConfirmBox}
          </div>

          <div
            className={`form__form-box form__form-box--with-space${errorAgreeWithTermsClass}`}
          >
            <div className="form__checkbox-out ver-top-box">
              <input
                className="form__checkbox dn"
                id="check-conditions"
                name="check-conditions"
                type="checkbox"
                value={this.props.agreeWithTerms}
                onChange={(event) => this.toggleCheckbox(event)}
              />
              <label
                className="form__check-label pr db"
                htmlFor="check-conditions"
              ></label>
            </div>
            <div className="form__link-conditions-out ver-top-box">
              <a
                className="form__link-conditions fs15"
                href="https://google.com"
              >
                {trans(this.props.trans, "auth.register.phone.terms")}
              </a>
            </div>
            {errorAgreeWithTermsBox}
          </div>

          {errorBox}

          <button
            className={`form__submit-btn btn btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={!passwordsCountIsValid || this.state.buttonDisabled}
          >
            {trans(this.props.trans, "auth.register.phone.button.title3")}
          </button>
        </form>
        {this.successModal()}
        {this.errorModal()}
      </div>
    );
  }
}

export default withRouter(withCookies(MobileStep3));
